import React from "react";
import { Table } from "semantic-ui-react";
import moment from "moment";

function FilaActividadesAsignadas(props) {
  const handleFechaInicio = () =>
    props.handleRowClick(
      "fechaIni",
      props.fechaIni,
      "Fecha de Inicio",
      props.id
    );

  const handleFechaFin = () =>
    props.handleRowClick(
      "fechaFin",
      props.fechaFin,
      "Fecha de Finalización",
      props.id
    );

  const handleAlumnos = () =>
    props.handleRowClick("alumnos", null, "AsignacionAlumnos", props.id);

  return (
    <Table.Row key={props.id}>
      <Table.Cell onClick={handleFechaInicio}>
        {moment(props.fechaIni, "YYYYMMDD").isValid()
          ? moment(props.fechaIni, "YYYYMMDD").format("DD/MM/YYYY")
          : "-"}
      </Table.Cell>
      <Table.Cell onClick={handleFechaFin}>
        {moment(props.fechaFin, "YYYYMMDD").isValid()
          ? moment(props.fechaFin, "YYYYMMDD").format("DD/MM/YYYY")
          : "-"}
      </Table.Cell>
      <Table.Cell onClick={handleAlumnos}>{props.actividad}</Table.Cell>
      <Table.Cell
        onClick={() =>
          props.handleRowClick("alumnos", null, "AsignacionAlumnos", props.id)
        }
      >
        {props.importe}
      </Table.Cell>
      <Table.Cell
        onClick={() =>
          props.handleRowClick(
            "noAmpa",
            props.noAmpa,
            "Incremento No AMPA",
            props.id
          )
        }
      >
        {props.noAmpa}
      </Table.Cell>
      <Table.Cell
        onClick={() =>
          props.handleRowClick(
            "noColegio",
            props.noColegio,
            "Incremento No Colegio",
            props.id
          )
        }
      >
        {props.noColegio}
      </Table.Cell>
      <Table.Cell
        onClick={() =>
          props.handleRowClick(
            "descuento",
            props.descuento,
            "Descuento",
            props.id
          )
        }
      >
        {props.descuento}
      </Table.Cell>
      <Table.Cell
        onClick={() =>
          props.handleRowClick("alumnos", null, "AsignacionAlumnos", props.id)
        }
      >
        {props.alumnos || 0}
      </Table.Cell>
    </Table.Row>
  );
}

export default FilaActividadesAsignadas;



// WEBPACK FOOTER //
// ./src/pages/shared/colegios/asignacionActividades/tablaActividadesAsignadas/FilaActividadesAsignadas.jsx